import React from 'react';
// import MaterialTable from "material-table";
import {tablePageRowsRate, defaultRowsRate} from '../../constants/ReusableTablePagination';
import GuiTable from '../../components/FormComponents/GuiTable';

function RateTables(props) {
  const editable = props.rateData.rateTableData?.map((o) => ({...o}));


  const columns = [
    {title: 'Rate ID', field: 'rate_id'},
    {title: 'Client ID', field: 'client_id'},
    {title: 'Client Name', field: 'parent_client_name'},
    {title: 'Service ID', field: 'service_type_id'},
    {title: 'Service', field: 'service_type'},
    {title: 'Sub Type / Scope', field: 'subtype'},
    {title: 'Fee Type', field: 'fee_type'},
    {title: 'Rate (In Dollars)', field: 'rate_in_dollars'},
    {title: 'Rate (In Percentage)', field: 'rate_in_percentage'},
    {title: 'Effective Date', field: 'effective_date'},
    {title: 'Termination Date', field: 'termination_date'},
  ];

  return (
    <div className="custom-table ">
      <GuiTable
        columns={columns}
        data={editable}
        title="Rate Table"
        options={{
          filtering: false,
          pageSize: defaultRowsRate,
          pageSizeOptions: tablePageRowsRate,
          search: true,
          emptyRowsWhenPaging: false,
        }}
      />
    </div>
  );
}

export default RateTables;
